module.exports = __webpack_public_path__ + "fe22d8b55c3ff7a370770ac9a68351f8.jpg";